import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) =>
  createStyles({
    authPage: {
      backgroundColor: theme.palette.background.main,
    },
    xl_container: {
      maxWidth: theme.breakpoints.values.lg,
    },
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      margin: `${theme.spacing(0)} 0 ${theme.spacing(0)} auto`,
      paddingTop: '1rem',
      paddingBottom: '2rem',
      paddingLeft: '81px',
    },
    main_footer: {
      marginTop: 'auto',
      marginBottom: '116px',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      width: '100%',
    },
    main_grid: {
      width: '100%',
      marginTop: 'auto',
      flexWrap: 'wrap',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
    },
    main_copyright: {
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '42.3%',
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: '2rem',
        marginBottom: '2rem',
      },
    },
    headline_wrp: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        width: '57%',
      },
      [theme.breakpoints.between('md', 'sm')]: {
        margin: `5rem 2rem 2rem`,
      },
      [theme.breakpoints.down('sm')]: {
        margin: `5rem auto 2rem`,
      },
    },
    headline_title: {
      fontWeight: 700,
      lineHeight: '100%',
      textTransform: 'uppercase',
      color: theme.palette.text.white,
      [theme.breakpoints.up('xs')]: {
        fontSize: '10vw',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '7vw',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 80,
      },
      '&:not(:last-child)': {
        marginBottom: theme.spacing(5),
      },
    },
    headline_subtitle: {
      fontWeight: 400,
      lineHeight: 1.5,
      color: theme.palette.text.white,
      maxWidth: 700,
      [theme.breakpoints.up('xs')]: {
        fontSize: '6vw',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '3vw',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 40,
      },
    },
    main_form_wrp: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('md')]: {
        width: '42.3%',
      },
    },
  })
)
export default useStyles
